module.exports = __webpack_public_path__ + "components/flag/static/square/tl-85bafcd9d11cff43092dbb51ad0aef7e.svg";